/* eslint-disable @typescript-eslint/no-unused-vars, no-unused-vars */
import { useEffect, useState } from "react";
// import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";

const PORTAL_ID = "8139412";
const FORM_ID = "8bae7cf2-eac6-4718-818f-9230d09640a5";
const REGION = "na1";
const TRACKING_SRC = `https://js.hs-scripts.com/${PORTAL_ID}.js`;
const FORMS_SRC = "https://js.hsforms.net/forms/embed/v2.js";
const SESSION_KEY = "hs-exit-intent-shown";
const FORM_TARGET_ID = "hs-exit-form";
const FORM_LABEL_CSS = `
  label,
  .hs-form-field > label,
  .hs-form-field > label span,
  .hs-form-required,
  .hs-field-desc,
  .hs-richtext,
  .hs-richtext p,
  .legal-consent-container,
  .legal-consent-container p,
  .hs-form-booleancheckbox-display,
  .hs-form-booleancheckbox-display span,
  .hs-form-checkbox-display span,
  .hs-form-radio-display span,
  .inputs-list label span {
    color: #1b3b4a !important;
    font-size: 14px !important;
    opacity: 1 !important;
    visibility: visible !important;
  }
`;

declare global {
  interface Window {
    hbspt?: {
      forms: {
        create: (options: {
          portalId: string;
          formId: string;
          region: string;
          target: string;
          css?: string;
          onFormReady?: (
            form: { get?: (index: number) => HTMLElement } | HTMLElement
          ) => void;
        }) => void;
      };
    };
  }
}

function formRoot(
  form: { get?: (index: number) => HTMLElement } | HTMLElement
): HTMLElement | null {
  if ("get" in form && form.get) return form.get(0) ?? null;
  return form as HTMLElement;
}

function paintLabels(root: HTMLElement) {
  root
    .querySelectorAll(
      "label, label span, .hs-richtext, .hs-richtext *, .legal-consent-container, .legal-consent-container *, .hs-form-booleancheckbox-display, .hs-form-booleancheckbox-display span"
    )
    .forEach((node) => {
      (node as HTMLElement).style.setProperty("color", "#1b3b4a", "important");
    });
}

function makeSingleChoice(root: HTMLElement) {
  root.querySelectorAll(".hs-form-field").forEach((field) => {
    const boxes = Array.from(
      field.querySelectorAll('input[type="checkbox"]')
    ) as HTMLInputElement[];
    if (boxes.length < 2) return;

    const legend = (
      field.querySelector(":scope > label")?.textContent || ""
    ).toLowerCase();
    const optionText = boxes
      .map((box) => box.value || box.parentElement?.innerText || "")
      .join(" ")
      .toLowerCase();
    const isChoiceGroup =
      legend.includes("select one") ||
      (optionText.includes("homeowner") && optionText.includes("renter"));
    if (!isChoiceGroup) return;

    const sharedName = boxes[0].name || "homeowner_or_renter";
    field.classList.add("hs-single-choice");
    boxes.forEach((box) => {
      box.type = "radio";
      box.name = sharedName;
    });
  });
}

function prepareForm(
  form: { get?: (index: number) => HTMLElement } | HTMLElement
) {
  const root = formRoot(form);
  if (!root?.querySelectorAll) return;
  paintLabels(root);
  makeSingleChoice(root);
}

function waitForHubspot(timeoutMs = 8000): Promise<void> {
  return new Promise((resolve, reject) => {
    const started = Date.now();
    const tick = () => {
      if (window.hbspt?.forms?.create) {
        resolve();
        return;
      }
      if (Date.now() - started > timeoutMs) {
        reject(new Error("HubSpot forms did not load"));
        return;
      }
      window.setTimeout(tick, 50);
    };
    tick();
  });
}

function loadScript(src: string, id: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const existing = document.getElementById(id) as HTMLScriptElement | null;
    if (existing) {
      if (existing.dataset.loaded === "true") {
        resolve();
        return;
      }
      existing.addEventListener("load", () => resolve(), { once: true });
      existing.addEventListener("error", () => reject(new Error(src)), {
        once: true,
      });
      return;
    }

    const script = document.createElement("script");
    script.id = id;
    script.src = src;
    script.async = true;
    script.defer = true;
    script.charset = "utf-8";
    script.onload = () => {
      script.dataset.loaded = "true";
      resolve();
    };
    script.onerror = () => reject(new Error(src));
    document.body.appendChild(script);
  });
}

export default function HubSpotExitIntent() {
  const [open, setOpen] = useState(false);
  const [formError, setFormError] = useState(false);

  useEffect(() => {
    loadScript(TRACKING_SRC, "hs-script-loader").catch(() => undefined);

    /*
    let armed = false;
    const armTimer = window.setTimeout(() => {
      armed = true;
    }, 1000);

    const show = () => {
      if (!armed) return;
      if (sessionStorage.getItem(SESSION_KEY) === "1") return;
      sessionStorage.setItem(SESSION_KEY, "1");
      setOpen(true);
    };

    const onMouseOut = (event: MouseEvent) => {
      if (event.clientY > 8) return;
      if (event.relatedTarget) return;
      show();
    };

    document.addEventListener("mouseout", onMouseOut);
    return () => {
      window.clearTimeout(armTimer);
      document.removeEventListener("mouseout", onMouseOut);
    };
    */
  }, []);

  /*
  useEffect(() => {
    if (!open) return;

    let cancelled = false;
    loadScript(FORMS_SRC, "hs-forms-embed-v2")
      .then(() => waitForHubspot())
      .then(() => {
        if (cancelled || !window.hbspt) return;
        const container = document.getElementById(FORM_TARGET_ID);
        if (!container || container.dataset.mounted === "true") return;
        container.dataset.mounted = "true";
        window.hbspt.forms.create({
          portalId: PORTAL_ID,
          formId: FORM_ID,
          region: REGION,
          target: `#${FORM_TARGET_ID}`,
          css: FORM_LABEL_CSS,
          onFormReady: (form) => {
            prepareForm(form);
            window.setTimeout(() => prepareForm(form), 400);
          },
        });
      })
      .catch(() => {
        if (!cancelled) setFormError(true);
      });

    return () => {
      cancelled = true;
    };
  }, [open]);
  */

  return null;

  /*
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      maxWidth="sm"
      fullWidth
      aria-labelledby="hs-exit-title"
      sx={{ zIndex: 12000 }}
      PaperProps={{
        sx: { borderRadius: "16px", px: 1, py: 0.5 },
      }}
    >
      <DialogTitle
        id="hs-exit-title"
        sx={{
          fontFamily: "Inter",
          color: "#17324a",
          fontWeight: 600,
          fontSize: "1.35rem",
          pr: 6,
          pb: 0,
        }}
      >
        Before you go
        <span
          style={{
            display: "block",
            marginTop: 6,
            fontSize: "0.95rem",
            fontWeight: 400,
            color: "#5d7383",
          }}
        >
          Share a few details and choose one option.
        </span>
        <IconButton
          aria-label="Close"
          onClick={() => setOpen(false)}
          sx={{ position: "absolute", right: 8, top: 8, fontSize: 28, lineHeight: 1 }}
        >
          ×
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <style>{`
          #${FORM_TARGET_ID} label,
          #${FORM_TARGET_ID} .hs-form-field > label,
          #${FORM_TARGET_ID} .hs-form-field > label span,
          #${FORM_TARGET_ID} .hs-form-required,
          #${FORM_TARGET_ID} .hs-field-desc,
          #${FORM_TARGET_ID} .hs-richtext,
          #${FORM_TARGET_ID} .hs-richtext p,
          #${FORM_TARGET_ID} .legal-consent-container,
          #${FORM_TARGET_ID} .legal-consent-container p,
          #${FORM_TARGET_ID} .hs-form-booleancheckbox-display,
          #${FORM_TARGET_ID} .hs-form-booleancheckbox-display span,
          #${FORM_TARGET_ID} .hs-form-checkbox-display span,
          #${FORM_TARGET_ID} .inputs-list label span {
            color: #1b3b4a !important;
            opacity: 1 !important;
            visibility: visible !important;
          }
          #${FORM_TARGET_ID} .hs-form-field > label {
            font-weight: 600 !important;
            margin-bottom: 6px !important;
          }
          #${FORM_TARGET_ID} .hs-input {
            width: 100% !important;
            min-height: 44px !important;
            border: 1px solid #d5dee6 !important;
            border-radius: 10px !important;
            padding: 10px 12px !important;
            color: #17324a !important;
            background: #fff !important;
            box-sizing: border-box !important;
          }
          #${FORM_TARGET_ID} .hs-input:focus {
            border-color: #2372b9 !important;
            outline: none !important;
            box-shadow: 0 0 0 3px rgba(35, 114, 185, 0.15) !important;
          }
          #${FORM_TARGET_ID} .hs-single-choice .inputs-list {
            list-style: none !important;
            margin: 8px 0 0 !important;
            padding: 0 !important;
            display: flex !important;
            gap: 12px !important;
          }
          #${FORM_TARGET_ID} .hs-single-choice .inputs-list li {
            list-style: none !important;
            flex: 1 !important;
            margin: 0 !important;
            padding: 0 !important;
          }
          #${FORM_TARGET_ID} .hs-single-choice .inputs-list li::before {
            content: none !important;
          }
          #${FORM_TARGET_ID} .hs-single-choice .inputs-list label {
            display: flex !important;
            align-items: center !important;
            justify-content: flex-start !important;
            gap: 10px !important;
            margin: 0 !important;
            padding: 12px 14px !important;
            border: 1px solid #d5dee6 !important;
            border-radius: 10px !important;
            background: #fff !important;
            cursor: pointer !important;
            width: 100% !important;
            box-sizing: border-box !important;
          }
          #${FORM_TARGET_ID} .hs-single-choice .inputs-list label:has(input:checked) {
            border-color: #2372b9 !important;
            background: #f3f8fc !important;
            box-shadow: 0 0 0 3px rgba(35, 114, 185, 0.12) !important;
          }
          #${FORM_TARGET_ID} .hs-single-choice input[type="radio"] {
            width: 18px !important;
            height: 18px !important;
            min-height: 18px !important;
            margin: 0 !important;
            padding: 0 !important;
            accent-color: #2372b9 !important;
            box-shadow: none !important;
            flex: 0 0 18px !important;
          }
          #${FORM_TARGET_ID} .hs-error-msgs {
            display: block !important;
            list-style: none !important;
            margin: 6px 0 0 !important;
            padding: 0 !important;
          }
          #${FORM_TARGET_ID} .hs-error-msgs li {
            display: block !important;
            flex: none !important;
            margin: 0 !important;
            padding: 0 !important;
            list-style: none !important;
          }
          #${FORM_TARGET_ID} .hs-error-msgs li::before {
            content: none !important;
          }
          #${FORM_TARGET_ID} .hs-error-msgs label,
          #${FORM_TARGET_ID} .hs-error-msg {
            display: block !important;
            margin: 0 !important;
            padding: 0 !important;
            border: none !important;
            background: transparent !important;
            box-shadow: none !important;
            color: #b42318 !important;
            font-size: 13px !important;
            font-weight: 500 !important;
            line-height: 1.4 !important;
          }
          #${FORM_TARGET_ID} .hs-input.error,
          #${FORM_TARGET_ID} .hs-input.invalid {
            border-color: #d92d20 !important;
            box-shadow: none !important;
          }
          #${FORM_TARGET_ID} .hs-button {
            width: 100% !important;
            min-height: 46px !important;
            margin-top: 8px !important;
            border: none !important;
            border-radius: 10px !important;
            background: #2372b9 !important;
            color: #fff !important;
            font-weight: 600 !important;
            cursor: pointer !important;
          }
          #${FORM_TARGET_ID} .hs-error-msg {
            color: #c62828 !important;
          }
        `}</style>
        {formError ? (
          <p>The form could not be loaded. Please try again later.</p>
        ) : (
          <div id={FORM_TARGET_ID} />
        )}
      </DialogContent>
    </Dialog>
  );
  */
}
